import "../../utils/tailwind.css";
import { NdaProvider, useNdaProvider } from "./provider";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import Section from "../../components/section";
import Label from "../../components/label";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Textarea } from "../../components/textarea";
import ImageUploader from "../../components/upload-image";
import Trash from "../../components/svg/trash";
import Plus from "../../components/svg/plus";

export default function AddNda() {
  return (
    <div className="p-3">
      <NdaProvider>
        <PageContent />
      </NdaProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = useNdaProvider();

  return (
    <Section className="h-[85vh] overflow-y-auto">
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}>
        {(formik) => (
          <Form>
            <Accordion defaultActiveKey="0" alwaysOpen>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Documents Details</Accordion.Header>
                <Accordion.Body>
                  <div className="flex flex-col">
                    <Label
                      label="Heading"
                      className="mb-2 text-black text-[15px]"
                    />
                    <FormikInput name="heading" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col mt-3">
                    <Label
                      label="Description"
                      className="mb-2 text-black text-[15px]"
                    />
                    <Textarea
                      name="desc"
                      value={formik.values.desc}
                      onChange={(e) =>
                        formik.setFieldValue("desc", e.target.value)
                      }
                      minRows={4}
                      rootClassName="w-full"
                    />
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Documents Files</Accordion.Header>
                <Accordion.Body>
                  <FieldArray name="nda_files">
                    {({ push, remove }) => (
                      <div className="flex flex-col">
                        <div className="flex justify-end  ">
                          <div className=" mt-3 bg-[black] p-1 rounded-full w-auto cursor-pointer">
                            <Plus
                              onClick={() => push({ file_name: "", file: "" })}
                              className={" text-[white]"}
                            />
                          </div>
                        </div>

                        <div className="mt-3 overflow-x-auto mb-10">
                          <table className="w-full border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[45%]">
                                  File Name
                                </th>
                                <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[45%]">
                                  File URL
                                </th>
                                <th className="border font-normal border-gray-300 px-4 py-2 text-center w-[10%]">
                                  Action
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {formik.values.nda_files.map((file, index) => (
                                <tr
                                  key={index}
                                  className="border border-gray-300">
                                  <td className="border border-gray-300 px-4 py-2 w-[45%]">
                                    <FormikInput
                                      name={`nda_files.${index}.file_name`}
                                      rootClassName="w-full"
                                    />
                                  </td>

                                  <td className="border border-gray-300 px-4 py-2 w-[45%]">
                                    <ImageUploader
                                      imageUrl={
                                        formik.values?.nda_files?.[index]?.file
                                      }
                                      onChange={(res) => {
                                        formik.setFieldValue(
                                          `nda_files.${index}.file`,
                                          res?.data?.file_url
                                        );
                                      }}
                                    />
                                  </td>

                                  <td className="border border-gray-300 text-center px-5 py-2 w-[10%]">
                                    <Trash
                                      className="cursor-pointer "
                                      type="button"
                                      onClick={() => remove(index)}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
